import React from 'react'
import { map } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import HandicapIcon from '../atoms/HandicapIcon'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: theme.spacing(45),
  },
  displayIcon: {
    flex: '0 0 25%',
    textAlign: '-webkit-center',
  },
}))

const VerticalHandicapIconList = (props) => {
  const { handicaps } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {map(handicaps, (value, slug) => (
        <div key={slug} className={classes.displayIcon}>
          <HandicapIcon value={value} slug={slug} />
        </div>
      ))}
    </div>
  )
}

export default VerticalHandicapIconList
